import { connect } from 'react-redux';

import { actions } from '../../../../attachmentsPreviewModal/actions/attachmentsPreviewModal';
import AttachmentsFieldList from '../../components/utils/AttachmentsFieldList';

const { attachmentsPreviewModalOpen } = actions;

const mapDispatchToProps = (dispatch: any) => {
  return {
    previewImage: (payload) => dispatch(attachmentsPreviewModalOpen(payload)),
  };
};

export default connect(null, mapDispatchToProps)(AttachmentsFieldList);
